import React from 'react';

import { Box, Typography } from '@mui/material';
import FormFooter from 'components/FormComponents/FormFooter';
import FormHeader from 'components/FormComponents/FormHeader';
import Modal from 'components/ModalV2';
import PropTypes from 'prop-types';

import styles from '../sidebar.module.css';

function LogoutConfirmDialog({ open, onClose, onConfirm }) {
    return (
        <Modal open={open} onClose={onClose} className={styles.logoutDialog}>
            <FormHeader
                title="Log out?"
                titleClassName={styles.logoutDialogTitle}
                handleClose={onClose}
                wrapperStyle={styles.logoutDialogHeader}
                hideDivider
            />
            <Box className={styles.logoutDialogBody}>
                <Typography className={styles.logoutDialogText}>
                    Are you sure you want to logout? You'll need to sign in again to use the portal.
                </Typography>
            </Box>
            <FormFooter
                btnText="Log out"
                secondaryBtnText="Cancel"
                secondaryBtnHandler={onClose}
                primaryBtnHandler={onConfirm}
                formType="onClick"
                isDanger
                btnContainerClassName={styles.logoutDialogFooter}
                hideDivider
            />
        </Modal>
    );
}

LogoutConfirmDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default LogoutConfirmDialog;
